module.exports = __webpack_public_path__ + "img/Girl_010015.f2aa28cb.png";